module.exports = __webpack_public_path__ + "assets/img/3061.e4fdf6ec.svg";